/**
 * Tour Preset Questions Component
 * Shows clickable question prompts users can ask
 */

import React from 'react';
import styled from 'styled-components';
import { PRESET_QUESTIONS, SECTION_QA } from '../../utils/interactiveTour';

const QuestionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
    padding: 0 4px;
`;

const QuestionButton = styled.button`
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.03);
    color: rgba(255, 255, 255, 0.85);
    text-align: left;
    
    &:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 35, 0, 0.3);
        color: #FFFFFF;
        transform: translateX(2px);
    }
    
    &:active {
        transform: scale(0.98);
    }
    
    @media (max-width: 480px) {
        padding: 10px 14px;
        font-size: 12px;
    }
`;

export const TourPresetQuestions = ({ onQuestionSelect, currentSection }) => {
    // Show section-specific questions if in a section, otherwise show general questions
    const questionsToShow = currentSection && SECTION_QA[currentSection] 
        ? SECTION_QA[currentSection].questions 
        : PRESET_QUESTIONS;
    
    return (
        <QuestionsContainer>
            {questionsToShow.map((question, index) => (
                <QuestionButton
                    key={index}
                    onClick={() => onQuestionSelect(question)}
                >
                    {question}
                </QuestionButton>
            ))}
        </QuestionsContainer>
    );
};

export default TourPresetQuestions;

